export const discountUnits = [
  {
    value: '%',
    name: '%',
  },
  {
    value: '€',
    name: '€',
  },
];

export const PERCENT = '%';
export const EURO = '€';
